import { Tab } from '../../../../../views/active-orders';

export default {
  title: 'Dashboard ristorante',
  tabs: {
    [Tab.OngoingOrders]: 'Prepara ora',
    [Tab.FutureOrders]: 'Futuri',
    [Tab.CompleteOrders]: 'Completati',
  },
  buttons: {
    order_history: 'Storico ordini',
  },
  feedback: {
    future_orders_alert: '⚠️ Non preparare ancora – ti avviseremo quando iniziare.',
  },
};
